module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "toc"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/KingofAirfighters_preface#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/KingofAirfighters_introduction#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/KingofAirfighters_part1#part1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "space"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/KingofAirfighters_part1#part1"
    }
  }, [_vm._v("EARLY LIFE—PART I")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    staticClass: "space1"
  })])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/KingofAirfighters_part2#part2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "space"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/KingofAirfighters_part2#part2"
    }
  }, [_vm._v("EARLY LIFE—PART II")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    staticClass: "space1"
  })])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofAirfighters_part3#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "space"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofAirfighters_part3#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEARNING TO FLY, AND FIRST FIRST OF DUTY IN FRANCE WITH NO. 40 SQUADRON")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    staticClass: "space1"
  })])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofAirfighters_part4#part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "space"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofAirfighters_part4#part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECOND TOUR OF DUTY IN FRANCE WITH NOS. 74 AND 85 SQUADRONS")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    staticClass: "space1"
  })])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofAirfighters_part5#part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "space"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofAirfighters_part5#part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KING OF AIRFIGHTERS")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    staticClass: "space1"
  })])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofAirfighters_part6#part6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "space"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/KingofAirfighters_part6#part6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L’ENVOI")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/KingofAirfighters_acknowledgments#acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Acknowledgements")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72436b0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KingofAirfighters_toc.vue
// module id = 66
// module chunks = 0